import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=3d1fdb44&scoped=true&"
import script from "./PageContainer.vue?vue&type=script&lang=js&"
export * from "./PageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1fdb44",
  null
  
)

export default component.exports